// extracted by mini-css-extract-plugin
export default {"st0":"ThumbsUpSvg_st0__64lG-","st1":"ThumbsUpSvg_st1__twTWr","st2":"ThumbsUpSvg_st2__EGI89","svgStyle":"ThumbsUpSvg_svgStyle__UjfN7"};